import { ForgotPasswordForm, Link } from '@/core'
import { AuthContent } from '@c/auth-app/auth-content'
import { useRouter } from '@u'
import { useTranslation } from 'react-i18next'

export const ForgotPasswordPage = () => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <AuthContent
      title={t('auth.forgotPasswordPage.title')}
      extra={
        <p>
          {t('auth.forgotPasswordPage.remember_password')}{' '}
          <Link name="login">{t('auth.forgotPasswordPage.login_link')}</Link>
        </p>
      }
    >
      <ForgotPasswordForm
        onSuccess={() => {
          router.push({ name: 'forgotPasswordSuccess' })
        }}
      />
    </AuthContent>
  )
}
